<style src="./UserList.scss" lang="scss"></style>

<template>
  <section class="user-list mail-box-header">
    <div class="title">
      <h4 class="text">Monitores Logados</h4>
      <div class="refresh" @click="refreshUserList">
        <i class="fa fa-refresh icon"></i>
      </div>
    </div>
    <div class="searchcontainer">
      <form class="formcontent" @submit.prevent="filterByNameOrPark">
        <div class="searcinputcontent">
          <input
            type="text"
            placeholder=" nome ou estacionamento"
            class="form-control"
            v-model="searchForm"
          />
        </div>
        <button class="btn btn-lg btn-primary searchbutton" type="submit">
          <i class="fa fa-search"></i>
        </button>
      </form>
      <div class="filtercontent">
        <button
          class="btn btn-lg btn-primary newmessagesfilter"
          type="button"
          @click="filterByNewMessages"
        >
          <i class="fa fa-filter"></i>
          <p class="filtersubtitle"></p>
        </button>
        <div class="totalnewmessages">
          <p class="totalnewmessagestext">{{ unreadList.length }}</p>
        </div>
      </div>
    </div>

    <ul class="userlist">
      <li
        class="item"
        v-for="(employee, employeeIdx) in filteredUserList"
        :key="employeeIdx"
        :class="[
          {
            item__selected: employee.userToken === $route.params.userToken,
          },
          {
            offline: !employee.isOnline,
          },
        ]"
        @click="selectUser(employee.userToken)"
      >
        <div
          class="status"
          :class="{ status__unread: unreadList.includes(employee.userToken) }"
        ></div>

        <div class="identification">
          <span class="name">{{ employee.fullName }}</span>
          <div class="parks">
            <span
              v-for="(park, parkIdx) in employee.device.parks"
              :key="parkIdx"
              :title="park"
              class="parkname"
              >{{ park.parkName.split(' ')[0] }}</span
            >
          </div>
        </div>

        <div class="info">
          <span class="appversion">v{{ employee.device.appVersion }}</span>
          <span
            class="batterystatus"
            :class="{ lowbattery: employee.device.batteryStatus <= 50 }"
            >{{ employee.device.batteryStatus }}%</span
          >
          <h3 class="lastlogin">Ultimo login</h3>
          <div class="authinfo" v-if="employee.lastLogin">
            <span class="dateLogin">{{ dateBR(employee.lastLogin.loginDate) }}</span>
            <span class="timeLogin">{{ timeBR(employee.lastLogin.loginDate) }}</span>
          </div>
        </div>

        <div class="dropdown">
          <button
            class="close toggledropdown"
            @click.stop="toggleDropdown(employeeIdx)"
            v-click-outside="onClickOutside"
          >
            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
          </button>

          <div v-if="showDropdown === employeeIdx" class="dropdowncontent">
            <button
              class="close employeebutton kioskbutton"
              @click="toogleKioskMode(employee.userToken)"
            >
              <i class="fa fa-lock" aria-hidden="true"></i>
              <span class="employeebuttontext">{{ employee.remoteSettings.isKioskModeActive
                  ? 'Desativar'
                  : 'Ativar' }}</span>
            </button>
            <button
              class="close employeebutton kioskbutton"
              @click="togglePrintTicket(employee.userToken)"
            >
              <i class="fa fa-print" aria-hidden="true"></i>
              <span class="employeebuttontext">{{ employee.remoteSettings.printTicket ? 'Desativar' : 'Ativar' }}</span>
            </button>

            <!-- <button
              class="close employeebutton trackerbutton"
              @click="
                toogleTracker(
                  employee.userToken,
                  !tracker.includes(employee.userToken),
                )
              "
            >
              <i class="fa fa-map-marker" aria-hidden="true"></i>
              <span class="employeebuttontext">{{ tracker.includes(employee.userToken) ? 'Desativar' : 'Ativar' }}</span>
            </button> -->

            <button
              class="close employeebutton singoutbutton"
              @click="logout(employee.userToken)"
            >
              <i class="fa fa-sign-out" aria-hidden="true"></i>
              <span class="employeebuttontext">logout</span>
            </button>

            <div class="employeebutton" v-if="employee.device.timeInfo">
              <h3 class="dateLogin">Hora atual</h3>
              <span class="dateLogin">{{ dateBR(employee.device.timeInfo.actualTime) }}</span>
              <span
                class="dateLogin"
                :class="{ different: employee.device.timeInfo.isDifferent }"
                >{{ timeBR(employee.device.timeInfo.actualTime) }}</span
              >
            </div>
          </div>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { format } from 'date-fns';
import { REMOTE_CONFIG, MESSAGES_EVENTS } from '@/config/config';
import socket from '@/store/socket';
import { toast } from '@/plugins/toast';

export default {
  name: 'UserList',
  data: () => ({
    userList: [],
    filteredUserList: [],
    searchForm: '',
    showDropdown: false,
  }),
  computed: {
    ...mapGetters({
      unreadList: 'MESSAGES/unreadMonitorMessages',
      tracker: 'MESSAGES/tracker',
      kioskMode: 'MESSAGES/kioskMode',
    }),
    showDropdownComputed(idx) {
      return this.showDropdown === idx;
    },
  },
  watch: {
    '$route.params.userToken': {
      handler(v) {
        if (v) {
          this.watchUserToken(v);
        }
      },
      immediate: true,
    },
    searchForm() {
      this.filterByNameOrPark();
    },
  },
  mounted() {
    this.refreshUserList();
    this.onRefreshList();
  },
  beforeUnmount() {
    this.$store.commit('MESSAGES/monitorMessages', []);
  },
  methods: {
    dateBR(v) {
      return format(new Date(v), 'MM/dd/yyyy');
    },
    timeBR(v) {
      if (!v) return v;
      return format(new Date(v), 'HH:mm:ss');
    },
    onRefreshList() {
      socket.on(MESSAGES_EVENTS.REFRESH_MONITORS, () => {
        this.refreshUserList();
      });
    },
    watchMonitor() {
      try {
        this.$store.dispatch('MESSAGES/WatchMonitor');
      } catch (error) {
        toast.error('Não foi observar usuários');
      }
    },
    async refreshUserList() {
      try {
        const monitors = await this.$store.dispatch(
          'MESSAGES/ListOnlineMonitors',
        );
        this.userList = monitors;
        this.filterByNameOrPark();
      } catch (error) {
        toast.error('Não foi possível listar os usuários');
      }
    },
    filterByNewMessages() {
      this.filteredUserList = this.userList.filter((user) =>
        this.unreadList.find((item) => item === user.userToken),
      );
    },
    filterByNameOrPark() {
      let listFiltered = this.userList.filter((item) => {
        return (
          item.fullName.toUpperCase().indexOf(this.searchForm.toUpperCase()) >
          -1
        );
      });
      if (listFiltered.length === 0) {
        listFiltered = this.userList
          .map((item) => {
            const found = item.device.parks.find((park) => {
              return (
                park.parkName
                  .toUpperCase()
                  .indexOf(this.searchForm.toUpperCase()) > -1
              );
            });
            return found ? item : null;
          })
          .filter((item) => item !== null);
      }
      this.filteredUserList = listFiltered;
    },
    watchUserToken(userToken) {
      try {
        this.$store.commit('MESSAGES/monitorMessages', []);
        this.$store.dispatch('MESSAGES/WatchUserMessage', userToken);
      } catch (error) {
        toast.error('Não foi possível listar as mensagens');
      }
    },
    selectUser(userToken) {
      if (this.$route.params.userToken === userToken) {
        return false;
      }
      this.$router.replace({
        name: 'MonitorMessageAttendance',
        params: { userToken },
      });
    },
    logout(userToken) {
      try {
        this.$store.dispatch('MESSAGES/SendRemoteConfig', {
          to: userToken,
          config: REMOTE_CONFIG.LOGOUT,
        });
        toast.success('Solicitação de logout enviada');
      } catch (error) {
        toast.error('Não foi possível enviar a solicitação de logout');
      }
    },
    // toogleTracker(userToken, tracker) {
    //   try {
    //     this.$store.dispatch('MESSAGES/SetEmployeeTracker', {
    //       userToken,
    //       tracker,
    //     });
    //     toast.success('Solicitação de tracker enviada');
    //   } catch (error) {
    //     toast.error('Não foi possível enviar a solicitação de tracker');
    //   }
    // },
    toogleKioskMode(userToken) {
      try {
        this.$store.dispatch('MESSAGES/SendRemoteConfig', {
          to: userToken,
          config: REMOTE_CONFIG.KIOSK_MODE,
        });
        toast.success('Solicitação de kiosk mode enviada');
      } catch (error) {
        toast.error(
          'Não foi possível enviar a solicitação de kiosk mode',
        );
      }
    },
    togglePrintTicket(userToken) {
      try {
        this.$store.dispatch('MESSAGES/SendRemoteConfig', {
          to: userToken,
          config: REMOTE_CONFIG.TICKET_PRINT,
        });
        toast.success('Solicitação de canhoto enviada');
      } catch (error) {
        toast.error('Não foi possível enviar a solicitação de canhoto');
      }
    },
    toggleDropdown(idx) {
      this.showDropdown = this.showDropdown === idx ? false : idx;
    },
    onClickOutside() {
      this.showDropdown = false;
    },
  },
};
</script>
